import { render, staticRenderFns } from "./Newlogin.vue?vue&type=template&id=737fb440&scoped=true&"
import script from "./Newlogin.vue?vue&type=script&lang=js&"
export * from "./Newlogin.vue?vue&type=script&lang=js&"
import style0 from "./Newlogin.vue?vue&type=style&index=0&id=737fb440&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737fb440",
  null
  
)

export default component.exports